import { render } from "./NotAuthorizedView.vue?vue&type=template&id=d63fedea&scoped=true"
import script from "./NotAuthorizedView.vue?vue&type=script&lang=js"
export * from "./NotAuthorizedView.vue?vue&type=script&lang=js"

import "./NotAuthorizedView.vue?vue&type=style&index=0&id=d63fedea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63fedea"]])

export default __exports__